import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";

export function useDeleteFullMbk(siteId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (years?: ReadonlyArray<string>) =>
      deleteFullMbk(siteId, years),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["mbks", { siteId }] });
    }
  });
}

async function deleteFullMbk(siteId: number, years?: ReadonlyArray<string>) {
  const deleteUrl = years
    ? urls.api.deleteFullMbkForYears(siteId, years)
    : urls.api.deleteFullMbk(siteId);
  return await api.delete(deleteUrl);
}
